import React, { FunctionComponent } from 'react';
import { graphql, createFragmentContainer } from 'react-relay';

import { PdpRequestAppointmentModal_item$ref } from './__generated__/PdpRequestAppointmentModal_item.graphql';
import { PdpRequestAppointmentModal_user$ref } from './__generated__/PdpRequestAppointmentModal_user.graphql';

const PdpRequestAppointmentModal = React.lazy(() =>
    import(/* webpackChunkName: "PdpRequestAppointmentModal" */ './PdpRequestAppointmentModal')
);

type Props = {
    isModalOpen: boolean;
    closeModal: () => void;
    item: PdpRequestAppointmentModal_item$ref;
    user: PdpRequestAppointmentModal_user$ref;
};

const PdpRequestAppointmentModalLoaderComponent: FunctionComponent<Props> = ({
    isModalOpen,
    closeModal,
    item,
    user,
}) => {
    return isModalOpen ? (
        <React.Suspense fallback={null}>
            <PdpRequestAppointmentModal onClose={closeModal} item={item} user={user} />
        </React.Suspense>
    ) : null;
};

const PdpRequestAppointmentModalLoader = createFragmentContainer(
    PdpRequestAppointmentModalLoaderComponent,
    {
        user: graphql`
            fragment PdpRequestAppointmentModalLoader_user on User {
                ...PdpRequestAppointmentModal_user
            }
        `,
        item: graphql`
            fragment PdpRequestAppointmentModalLoader_item on Item {
                ...PdpRequestAppointmentModal_item
            }
        `,
    }
);

export default PdpRequestAppointmentModalLoader;
